/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, input } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-custom-error-display',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './custom-error-display.component.html',
})
export class CustomErrorDisplayComponent {
  control = input<AbstractControl | NgControl | null>(null);
  errors = input<{ [key: string]: string }>({});

  constructor(private _translate: TranslateService) {}

  get errorEntries(): { key: string; value: any }[] {
    if (!this.actualControl?.errors) {
      return [];
    }
    return Object.entries(this.actualControl.errors).map(([key, value]) => ({ key, value }));
  }

  get actualControl(): AbstractControl | null {
    if (!this.control()) {
      return null;
    }
    const currentControl = this.control();
    return currentControl instanceof NgControl ? currentControl.control : currentControl;
  }

  shouldShowErrors(): boolean {
    const ctrl = this.actualControl;
    return !!(ctrl && ctrl.invalid && ctrl.touched);
  }

  getErrorMessage(errorCode: string, errorValue: any): string {
    const customMessage = this.errors()?.[errorCode];
    if (customMessage) {
      return this._translate.instant(customMessage, errorValue);
    }

    const key = `SHARED.INPUTS_CUSTOM-ERROR-DISPLAY.${errorCode.toUpperCase()}`;
    const translation = this._translate.instant(key, errorValue);

    // Si la traducción es igual a la clave, significa que no se encontró una traducción.
    if (translation === key) {
      return this._translate.instant('SHARED.INPUTS_CUSTOM-ERROR-DISPLAY.REQUIRED');
    }

    return translation;
  }
}
